module.exports = __webpack_public_path__ + "img/weather-coupon-expired.45de8d89.png";